import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Wmv"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21.75 6.75L20.25 16.5L18.75 6.75H17.25L19.14 17.25H21.36L23.25 6.75H21.75ZM14.25 6.75L13.11 10.5L12.75 11.985L12.405 10.5L11.25 6.75H9.75V17.25H11.25V11.25L11.13 9.75L11.565 11.25L12.75 14.7225L13.935 11.25L14.37 9.75L14.25 11.25V17.25H15.75V6.75H14.25ZM6.9 6.75L6.645 12.75L6.45 16.155L6.1425 13.5L5.6325 9.405H4.1175L3.6075 13.5L3.3 16.155L3.105 12.75L2.85 6.75H1.5L2.25 17.25H3.9525L4.5225 13.5525L4.8675 10.5L4.875 10.4775L4.8825 10.5L5.2275 13.5525L5.7975 17.25H7.5L8.25 6.75H6.9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Wmv.vue"]]);
